module.exports = __webpack_public_path__ + "img/facebook-icon.0a05ba81.svg";